import { plural } from '@cian/utils';
import { NBSP } from '../../constants/symbols';

// Именительный или родительный падеж
type TPluralCase = 'nominative' | 'genitive';

type TPluralCases = {
  [key in TPluralCase]: [string, string, string];
};

interface IPluralDaysParams {
  pluralCase?: TPluralCase;
  excludeOne?: boolean;
}

const PLURAL_CASES: TPluralCases = {
  // 1 день, 2 дня, 5 дней
  nominative: ['день', 'дня', 'дней'],
  // в течение 1 дня, 2 дней, 5 дней
  genitive: ['дня', 'дней', 'дней'],
};

/**
 *
 * @description Склоняет дни в указанном падеже
 */
export function pluralDays(days: number, params?: IPluralDaysParams) {
  const { pluralCase = 'nominative', excludeOne = false } = params || {};

  const daysWord = plural(days, PLURAL_CASES[pluralCase]);

  if (excludeOne && days === 1) {
    return daysWord;
  }

  return `${days}${NBSP}${daysWord}`;
}
